import Opening from '../components/Opening';

/** All the work happens in verifyLoader; this is what shows while it runs. */
export default function Verify() {
  return <Opening />;
}
